import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../../pages/settings/settings.helpers';

export interface ImageCropDialogProps {
  handleClose: any;
  handleSubmit: any;
  isLoading: boolean;
  isOpen: boolean;
  image: any;
}

export default function ImageCropDialog(props: ImageCropDialogProps) {
  const [crop, setCrop] = React.useState({ x: 0, y: 0 });
  const [imageURL] = React.useState(props.image);
  const [zoom, setZoom] = React.useState(1);
  const [imageDimensions, setImageDimensions] = React.useState({
    croppedArea: null,
    croppedAreaPixels: null,
  });
  const onCropComplete = React.useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setImageDimensions({ croppedAreaPixels, croppedArea });
  }, []);

  const showCroppedImage = async () => {
    try {
      const croppedImage = await getCroppedImg(imageURL, imageDimensions.croppedAreaPixels, 0);
      return croppedImage;
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog open={props.isOpen} onClose={props.handleClose}>
      <DialogTitle>Crop Profile Image</DialogTitle>
      <DialogContent
        style={{ display: 'flex', minWidth: 600, flexDirection: 'column', padding: 10, alignItems: 'center' }}
      >
        <div style={{ maxHeight: 200, maxWidth: 300, minHeight: 200, minWidth: 300, position: 'relative' }}>
          <Cropper
            image={imageURL}
            crop={crop}
            zoom={zoom}
            aspect={1 / 1}
            objectFit="vertical-cover"
            cropShape="round"
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} color="error">
          Cancel
        </Button>
        <Button onClick={async () => props.handleSubmit(await showCroppedImage())} disabled={props.isLoading}>
          Crop
        </Button>
      </DialogActions>
    </Dialog>
  );
}
